<template>
  <div class="container search-box">
    <input type="text" v-model="search" @keyup="keyWatcher" class="search-box__input" />
    <button @click.prevent="doSearch" type="button" class="search-box__button">
      Buscar
    </button>
  </div>
</template>

<script>
export default {
  data: () => ({
    // search: ''
  }),
  computed: {
    search: {
      get() {
        return this.$store.state.search.term
      },
      set(value) {
        this.$store.commit('search/setTerm', value)
      }
    }
  },
  created() {
    if (this.search) {
      this.doSearch()
    }
  },
  methods: {
    keyWatcher(e) {
      if (e.key == 'Enter') {
        this.doSearch()
      }
    },
    doSearch() {
      this.$store.dispatch('search/search')
    }
  }
}
</script>
